import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, finalize, takeWhile } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import Configs from '@shared/constants/configs';
import Utils from '@shared/utils/utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SearchFilterNameComponent } from '@routes/dialogs/search-filter-name/search-filter-name.component';
import Swal from 'sweetalert2';
import SharedStorage from '@shared/services/shared-storage';
import { MasterCode } from '@shared/enums/master-code';
import { Constants } from '@shared/constants/constants';
import { Company } from '@shared/enums/company';
import Roles from '@shared/constants/roles';

@Component({
  selector: 'app-ticket-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent extends DialogBase implements OnInit {
  readonly filterKey = 'filter';


  title: any;
  filter: any;
  defaultFilter: any;
  disableFilter: any;
  isSystemFilter: any;
  isMyList: any;

  ticketFilter: any;

  dealerStoreForm: FormGroup;
  customerTypeForm: FormGroup;
  detailTypeForm: FormGroup;
  serviceTypeForm: FormGroup;
  productGroupForm: FormGroup;
  statusForm: FormGroup;
  redoForm: FormGroup;
  provinceForm: FormGroup;
  dealerForm: FormGroup;
  storeForm: FormGroup;
  soStatusForm: FormGroup;
  srStatusForm: FormGroup;
  searchText = new FormControl(null);

  isDealerStoreCheckAll = false;
  isCustomerTypeCheckAll = false;
  isDetailTypeCheckAll = false;
  isServiceTypeCheckAll = false;
  isProductCheckAll = false;
  isStatusCheckAll = false;
  isRedoCheckAll = false;
  isProvinceCheckAll = false;
  isDealerCheckAll = false;
  isStoreCheckAll = false;
  isSoStatusCheckAll = false;
  isSrStatusCheckAll = false;

  dealerStore: any;
  serviceType: any;
  detailType: any;
  categories: any;
  productCategories: any;
  status: any;
  redo: any;
  province: any;
  dealer: any;
  store: any;
  soStatus: any;
  srStatus: any;
  secaStatus: any;


  dealerStoreList: any = [];
  customerTypes: any = [{
    code: 'customer',
    name: 'Customer'
  }, {
    code: 'store',
    name: 'Store'
  }];
  redoList: any = [{
    code: 'redo',
    name: 'Redo (R)'
  }, {
    code: 'nonRedo',
    name: 'Non-redo'
  }];
  serviceTypes: any = [];
  detailTypes: any = [];
  productCategoriesList: any = [];
  statusList: any = [];
  provinceList: any = Constants.canadaProvinces;
  dealerList: any = [];
  storeList: any = [];
  soStatusList: any = [];
  srStatusList: any = [];

  selectedDealerStore: any = [];
  selectedCategoryIds: any = [];
  selectedServiceTypes: any = [];
  selectedDetailTypes: any = [];
  selectedCustomerTypes: any = [];
  selectedRedoStatus: any = [];
  selectedStatus: any = [];
  selectedProvince: any = [];
  selectedDealer: any = [];
  selectedStore: any = [];
  selectedSoStatus: any = [];
  selectedSrStatus: any = [];

  isOpen = false;

  mappingKey = {
    dealerStore: {
      form: 'dealerStoreForm',
      selectedName: 'selectedDealerStore',
      listName: 'dealerStoreList',
      isCheck: 'isDealerStoreCheckAll'
    },
    categoryId: {
      form: 'productGroupForm',
      selectedName: 'selectedCategoryIds',
      listName: 'productCategoriesList',
      isCheck: 'isProductCheckAll'
    },
    customerType: {
      form: 'customerTypeForm',
      selectedName: 'selectedCustomerTypes',
      listName: 'customerTypes',
      isCheck: 'isCustomerTypeCheckAll'
    },
    redoType: {
      form: 'redoForm',
      selectedName: 'selectedRedoStatus',
      listName: 'redoList',
      isCheck: 'isRedoCheckAll'
    },
    detailType: {
      form: 'detailTypeForm',
      selectedName: 'selectedDetailTypes',
      listName: 'detailTypes',
      isCheck: 'isDetailTypeCheckAll'
    },
    serviceType: {
      form: 'serviceTypeForm',
      selectedName: 'selectedServiceTypes',
      listName: 'serviceTypes',
      isCheck: 'isServiceTypeCheckAll'
    },
    status: {
      form: 'statusForm',
      selectedName: 'selectedStatus',
      listName: 'statusList',
      isCheck: 'isStatusCheckAll'
    },
    province: {
      form: 'provinceForm',
      selectedName: 'selectedProvince',
      listName: 'provinceList',
      isCheck: 'isProvinceCheckAll'
    },
    dealer: {
      form: 'dealerForm',
      selectedName: 'selectedDealer',
      listName: 'dealerList',
      isCheck: 'isDealerCheckAll'
    },
    store: {
      form: 'storeForm',
      selectedName: 'selectedStore',
      listName: 'storeList',
      isCheck: 'isStoreCheckAll'
    },
    soStatus: {
      form: 'soStatusForm',
      selectedName: 'selectedSoStatus',
      listName: 'soStatusList',
      isCheck: 'isSoStatusCheckAll'
    },
    srStatus: {
      form: 'srStatusForm',
      selectedName: 'selectedSrStatus',
      listName: 'srStatusList',
      isCheck: 'isSrStatusCheckAll'
    },
  }

  newBsModalRef: BsModalRef = null;

  // SEA/SEA_IM: stores are no longer all loaded up front. The picked HQs decide
  // what the Store column holds, so the checkbox form only ever covers what is
  // currently listed and cannot be the source of truth for the payload.
  hqOptions: any[] = [];
  selectedHqIds: string[] = [];
  showHqPicker = false;
  storesLoading = false;
  storeNotice = '';
  // survives list rebuilds (HQ change, search) — this is what setQuery emits
  selectedStoreIds = new Set<string>();
  readonly hqSelectionMax = 10;
  readonly storeRowNotice = 2000;

  company;
  country;
  companies = Company;
  isAdmin = false;

  ngOnInit(): void {
    // console.log('::::::::', this.isMyList, this.isSystemFilter, this.defaultFilter)
    this.company = this.authService.getCurrentCompany();
    this.country = this.authService.getCurrentCountry(this.company);
    this.isAdmin = this.authService.hasType(Roles.dealerNewView);
    this.province = Constants.canadaProvinces;
    this.title = 'Filter';
    this.ticketFilter = JSON.parse(SharedStorage.getItem(this.filterKey));

    // was (change), so it only fired on blur/Enter
    this.searchText.valueChanges
      .pipe(debounceTime(200), distinctUntilChanged(), takeWhile(() => this.alive))
      .subscribe(() => this.applyStoreSearch());

    this.load();
  }


  get isSeaFamily() {
    return [Company.Sea, Company.SeaIm].includes(this.company);
  }

  async load() {
    this.spinnerService.start();

    const codes = [
      MasterCode.ServiceType,
      MasterCode.DealerPortalServiceTypes,
      MasterCode.DetailType,
      MasterCode.ProductCategories,
    ].join(',');

    const getConstants = this.apiService.master.getCommonConstantList(codes);
    const getStatus = this.apiService.master.getStatusForFilter(Configs.defaultDetailType);
    const getProductCategories = this.apiService.master.getProductCategories();
    // SEA/SEA_IM load stores per picked HQ, so neither whole-universe call is
    // made there. SECA still drives its Dealer/Province/Store cascade from the
    // in-memory list and keeps code-with-state.
    const getDealersWithState = this.isSeaFamily
      ? of([])
      : this.apiService.dealer.getDealerCodesWithState();

    forkJoin([getConstants, getStatus, getProductCategories, getDealersWithState])
      .pipe(finalize(() => {
        this.spinnerService.stop();
        this.initForm();
        this.selectedFilter(this.filter);
      }))
      .subscribe(([resConstants, resStatus, resProductCategories, resDealersWithState]) => {
        const { ServiceType, DetailType, ProductCategories, DealerPortalServiceTypes } = resConstants;

        this.serviceType = ServiceType;
        this.detailType = DetailType;
        this.productCategories = resProductCategories.length ? resProductCategories : ProductCategories;
        this.status = resStatus;
        this.secaStatus = resStatus;
        // starts empty for SEA/SEA_IM; filled once an HQ is picked
        this.dealerStore = [];
        this.dealer = (resDealersWithState || []).filter(dealer => dealer.hq);
        this.store = resDealersWithState || [];
      });

    if (this.isSeaFamily) {
      this.loadHqOptions();
    }
  }

  // the header already fetches this list on app entry; reuse it rather than
  // asking again
  private loadHqOptions() {
    this.authService.getHqDealers$()
      .pipe(takeWhile(() => this.alive))
      .subscribe(hqs => {
        this.hqOptions = hqs || [];
        // one HQ (or none) means there is nothing to pick — load it straight away
        this.showHqPicker = this.hqOptions.length > 1;
        if (this.hqOptions.length === 1 && !this.selectedHqIds.length) {
          this.selectedHqIds = [this.hqOptions[0].code];
          this.fetchStoresForHqs(this.selectedHqIds);
        }
        if (!this.hqOptions.length) {
          this.storeNotice = 'No dealers available.';
        }
      });
  }

  onHqChange(hqIds: string[]) {
    this.selectedHqIds = (hqIds || []).slice(0, this.hqSelectionMax);
    if (!this.selectedHqIds.length) {
      this.dealerStore = [];
      this.rebuildStoreForms([]);
      this.storeNotice = '';
      return;
    }
    this.fetchStoresForHqs(this.selectedHqIds);
  }

  private fetchStoresForHqs(hqIds: string[]) {
    this.storesLoading = true;
    this.apiService.dealer.getFilterStores({ hqIds })
      .pipe(finalize(() => this.storesLoading = false))
      .subscribe(stores => {
        this.dealerStore = stores || [];
        this.applyStoreSearch();
        this.storeNotice = this.dealerStore.length > this.storeRowNotice
          ? `${ this.dealerStore.length } stores loaded. Narrow by HQ to speed this up.`
          : '';
      }, err => Utils.showError(err));
  }

  // rebuilds the visible list and the form together — keeping them in step is
  // what stops the All checkbox and the saved selection from drifting apart
  private applyStoreSearch() {
    const term = (this.searchText.value || '').trim().toLowerCase();
    const matched = term
      ? this.dealerStore.filter(store => String(store.name || '').toLowerCase().includes(term))
      : this.dealerStore;
    this.rebuildStoreForms(matched);
  }

  private rebuildStoreForms(stores: any[]) {
    this.dealerStoreList = (stores || []).map(store => ({ name: store.name, code: store.code }));
    const query = {};
    this.dealerStoreList.forEach(store => {
      query[store.code] = this.selectedStoreIds.has(String(store.code));
    });
    this.dealerStoreForm = this.fb.group(query);
    this.changeCheckBoxStatus(this.dealerStoreForm, 'dealerStore');
  }

  onStoreToggle(code) {
    const id = String(code);
    if (this.dealerStoreForm.controls[id]?.value) {
      this.selectedStoreIds.add(id);
    } else {
      this.selectedStoreIds.delete(id);
    }
    this.changeCheckBoxStatus(this.dealerStoreForm, 'dealerStore');
  }

  initForm(init = true) {
    this.customerTypeForm = this.fb.group({
      customer: false,
      store: false,
    });

    this.redoForm = this.fb.group({
      redo: false,
      nonRedo: false,
    });

    // idempotent: rebuildStoreForms replaces the list instead of appending, so a
    // second initForm(false) from clearFilter cannot duplicate rows
    this.rebuildStoreForms(this.dealerStore || []);

    let query = {};
    Object.keys(this.detailType).forEach(key => {
      if (init) {
        this.detailTypes.push({
          code: this.detailType[key].code,
          name: key
        })
      }

      query[this.detailType[key].code] = {
        ['value']: this.detailType[key].code === 'DET001',
        disabled: true
      };
    });
    this.detailTypeForm = this.fb.group(query);

    query = {};
    Object.keys(this.serviceType).forEach(key => {
      if (this.serviceType[key].dealer) {
        if (init) {
          this.serviceTypes.push({
            code: this.serviceType[key].code,
            name: this.serviceType[key].name
          });
        }
        query[this.serviceType[key].code] = false;
      }
    });
    this.serviceTypeForm = this.fb.group(query);

    query = {};
    this.productCategories.forEach(key => {
      if (init) {
        this.productCategoriesList.push({
          code: key.category,
          name: this.changeCodeToName(key.category),
        });
      }
      query[key.category] = false;
    });
    this.productGroupForm = this.fb.group(query);

    query = {};
    Object.keys(this.status).forEach(key => {
      if (init) {
        this.statusList.push({
          name: this.status[key].name,
          code: key
        })
      }
      if (!init && this.disableFilter.status && this.filter.status.$in.includes(key)) {
        query[key] = true;
        return;
      }
      query[key] = false;
    });
    this.statusForm = this.fb.group(query);

    //state for seca
    query = {};
    Object.keys(this.province).forEach(key => {
      query[this.province[key].code] = false;
    });
    this.provinceForm = this.fb.group(query);

    //dealer for seca
    query = {};
    Object.keys(this.dealer).forEach(key => {
      if (init) {
        this.dealerList.push({
          name: this.dealer[key].name,
          code: this.dealer[key].code,
        });
      }
      query[this.dealer[key].code] = false;
    });
    this.dealerForm = this.fb.group(query);

    //store for seca
    query = {};
    Object.keys(this.store).forEach(key => {
      if (init) {
        this.storeList.push({
          name: this.store[key].name,
          code: this.store[key].code,
          hqBpNo: this.store[key].hqBpNo,
        });
      }
      query[this.store[key].code] = false;
    });
    this.storeForm = this.fb.group(query);

    //srStatus for seca
    query = {};
    Object.keys(this.secaStatus).forEach(key => {
      if (key.indexOf('_SR_') !== -1) {
        if (init) {
          this.srStatusList.push({
            name: this.secaStatus[key].name,
            code: this.secaStatus[key].code,
          })

        }
        query[this.secaStatus[key].code] = false;
      }
    });
    this.srStatusForm = this.fb.group(query);

    //soStatus for seca
    query = {};
    Object.keys(this.secaStatus).forEach(key => {
      if (key.indexOf('_SO_') !== -1) {
        if (init) {
          this.soStatusList.push({
            name: this.secaStatus[key].name,
            code: this.secaStatus[key].code,
          })
        }
        query[this.secaStatus[key].code] = false;
      }
    });
    this.soStatusForm = this.fb.group(query);
  }

  changeCodeToName(code) {
    const productNameList = {
      ACN: 'Air Conditioner',
      AUD: 'Audio Device',
      CAM: 'Camera',
      CLE: 'Cleaner',
      COM: 'Computer',
      HHP: 'Mobile Phone',
      HKE: 'Home Kitchen Electronics',
      MON: 'Monitor',
      PRT: 'Printer',
      SSD: 'Solid State Drive',
      VDE: 'Visual Display Electronics',
      VEE: 'Visual Entertainment Electronics',
      HME: 'Health care',
      WSM: 'Washing Machine (Washer)',
      REF: 'Refrigerator',
    };

    if (productNameList.hasOwnProperty(code)) {
      return productNameList[code];
    } else {
      return code
    }
  }


  applyFilter() {
    this.setQuery();

    // Manual Add detailType
    this.filter = {
      ...this.filter,
      ...{ detailType: ['DET001'] },
    }

    this.onClose.next(this.filter);
    this.bsModalRef.hide();
  }

  setQuery() {
    // Clear all selected arrays to prevent duplicates
    this.selectedDealerStore = [];
    this.selectedCategoryIds = [];
    this.selectedServiceTypes = [];
    this.selectedDetailTypes = [];
    this.selectedCustomerTypes = [];
    this.selectedRedoStatus = [];
    this.selectedStatus = [];
    this.selectedProvince = [];
    this.selectedDealer = [];
    this.selectedStore = [];
    this.selectedSoStatus = [];
    this.selectedSrStatus = [];

    const selectedFormSetValue = (x) => {
      for (const name in this[x.form].getRawValue()) {
        if (this[x.form].controls[name].value) {
          this[x.selectedName].push(name);
        }
      }
    };

    const setFilter = (addFilter) => {
      this.filter = {
        ...this.filter,
        ...addFilter
      }
    };

    Object.keys(this.mappingKey).forEach(key => {
      if (key === 'dealerStore' && this.isSeaFamily) {
        // read the sticky set, not the form: the form only covers the stores
        // currently listed, so a selection under an unloaded HQ would vanish
        this.selectedDealerStore = Array.from(this.selectedStoreIds);
      } else {
        selectedFormSetValue(this.mappingKey[key]);
      }

      if (this[this.mappingKey[key].selectedName].length) {
        const addFilter = {};
        addFilter[key] = this[this.mappingKey[key].selectedName];
        setFilter(addFilter);
      } else {
        delete this.filter[key];
      }
    })
  }


  clearFilter() {
    this.initForm(false);
    delete this.filter.categoryId;
    delete this.filter.serviceType;
    delete this.filter.customerType;
    delete this.filter.redoType;
    delete this.filter.detailType;
    delete this.filter.dealerStore;
    if (!this.disableFilter.status) {
      delete this.filter.status;
    }
    delete this.filter.province;
    delete this.filter.dealer;
    delete this.filter.store;
    if (!this.disableFilter.srStatus) {
      delete this.filter.srStatus;
    }
    if (!this.disableFilter.soStatus) {
      delete this.filter.soStatus;
    }

    this.selectedStoreIds.clear();
    this.storeNotice = '';

    this.isDealerStoreCheckAll = false;
    this.isCustomerTypeCheckAll = false;
    this.isDetailTypeCheckAll = false;
    this.isServiceTypeCheckAll = false;
    this.isProductCheckAll = false;
    this.isStatusCheckAll = false;
    this.isProvinceCheckAll = false;
    this.isDealerCheckAll = false;
    this.isStoreCheckAll = false;
    this.isSrStatusCheckAll = false;
    this.isSoStatusCheckAll = false;
    this.isRedoCheckAll = false;

    // this.selectedFilter(this.defaultFilter);
  }

  selectedFilter(filter) {
    if (Utils.isEmpty(filter)) {
      this.setFormDisable();
      this.setStores(true);
      return;
    }

    // the saved dealerStore ids are the payload; the checkbox form only mirrors
    // whichever of them happen to be listed right now
    (filter.dealerStore || []).forEach(id => this.selectedStoreIds.add(String(id)));

    const setFormData = (arr, mapping) => {
      for (const id of arr) {
        const control = this[mapping.form].controls[id];
        // a saved id whose option no longer exists (store deactivated, access
        // revoked, or simply not loaded yet) must not take the dialog down
        if (!control) {
          console.warn(`[filter] no control for ${ mapping.form }.${ id }`);
          continue;
        }
        control.setValue(true);
      }

      // meaningless for the store column once the list is loaded per HQ
      if (mapping.form !== 'dealerStoreForm' && arr && this[mapping.listName].length === arr.length) {
        this[mapping.isCheck] = true;
      }
    };

    Object.keys(filter).forEach(key => {
      const filterArr = filter[key];
      if (this.mappingKey[key] && filterArr?.length) {
        setFormData(filterArr, this.mappingKey[key]);
      }
    });

    this.setFormDisable();
    this.setStores(true);

    if (this.isSeaFamily && this.selectedStoreIds.size) {
      this.rehydrateSavedStores();
    }
  }

  // A saved filter names stores, not HQs, so the column would open empty and
  // Apply would look like it had dropped the selection. Listing exactly the
  // saved stores shows it instead, and avoids pulling the whole HQ back — one
  // saved filter here held ~900 stores, and the largest HQ has 4,682. Picking an
  // HQ replaces the list with that HQ's stores, which is how more are reached.
  private rehydrateSavedStores() {
    const savedIds = Array.from(this.selectedStoreIds);
    this.storesLoading = true;
    this.apiService.dealer.getFilterStores({ storeIds: savedIds })
      .pipe(finalize(() => this.storesLoading = false))
      .subscribe((rows: any[]) => {
        const found = rows || [];
        // ids the server will not return are gone for this user; keep filtering
        // on them and the result is silently wrong
        const stillVisible = new Set(found.map(r => String(r.code)));
        const dropped = savedIds.filter(id => !stillVisible.has(id));
        dropped.forEach(id => this.selectedStoreIds.delete(id));

        const hqIds = Array.from(new Set(found.map(r => String(r.hqId)).filter(Boolean)));
        this.selectedHqIds = hqIds.slice(0, this.hqSelectionMax);

        this.dealerStore = found;
        this.applyStoreSearch();
        this.storeNotice = dropped.length
          ? `${ dropped.length } saved store(s) are no longer available.`
          : `Showing the ${ found.length } saved store(s). Pick an HQ to see all of its stores.`;
      }, err => Utils.showError(err));
  }

  setFormDisable() {
    if (this.disableFilter.status) {
      this.statusForm.disable();
    }
  }

  onOpenChange($event: boolean) {
    setTimeout(() => {
      this.isOpen = $event;
    });
  }

  filterAction(action) {
    let { _id, name } = this.ticketFilter;

    if (action === 'delete') {
      this.spinnerService.start();
      this.apiService.ticket.deleteTicketFilter(_id)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          Swal.fire({
            icon: 'success',
            title: 'Delete Success!!',
            showConfirmButton: false,
            timer: 1500
          }).then((result) => {
            this.onClose.next(null);
            this.bsModalRef.hide();
          });
        }, err => Utils.showError(err));

      return;
    }

    const isNew = action === 'save';

    let title = action === 'rename' ? 'Rename' : 'Save';
    if (this.isMyList && this.isSystemFilter || !this.isMyList && this.isSystemFilter) {
      title = 'New';
      name = null;
    }

    const initialState = {
      title,
      name: name || ''
    };

    this.newBsModalRef = this.modalService.show(SearchFilterNameComponent, {
      initialState,
      class: 'modal-filter-name'
    });
    this.newBsModalRef.content.onClose.subscribe(name => {
      if (name) {
        // Update filter with current form values before saving
        this.setQuery();

        // Manual Add detailType
        this.filter = {
          ...this.filter,
          ...{ detailType: ['DET001'] },
        }

        let params: any = {
          name,
          filter: this.filter
        };

        if (_id) {
          params = {
            ...params,
            id: _id
          }
        }

        this.spinnerService.start();
        this.apiService.ticket.saveTicketFilter(params, isNew)
          .pipe(finalize(() => this.spinnerService.stop()))
          .subscribe(res => {
            if (res) {
              SharedStorage.setItem(this.filterKey, JSON.stringify(res));
            }
            Swal.fire({
              icon: 'success',
              title: 'Save Success!',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              this.applyFilter();
            });
          }, err => Utils.showError(err));
      }

      this.newBsModalRef = null;
    });

  }

  changeCheckAll(form, type) {

    let typeCheckAll;
    switch (type) {
      case 'dealerStore' :
        this.isDealerStoreCheckAll = !this.isDealerStoreCheckAll;
        typeCheckAll = this.isDealerStoreCheckAll;
        break;
      case 'customer' :
        this.isCustomerTypeCheckAll = !this.isCustomerTypeCheckAll;
        typeCheckAll = this.isCustomerTypeCheckAll;
        break;
      case 'detail' :
        this.isDetailTypeCheckAll = !this.isDetailTypeCheckAll;
        typeCheckAll = this.isDetailTypeCheckAll;
        break;
      case 'service' :
        this.isServiceTypeCheckAll = !this.isServiceTypeCheckAll;
        typeCheckAll = this.isServiceTypeCheckAll;
        break;
      case 'product' :
        this.isProductCheckAll = !this.isProductCheckAll;
        typeCheckAll = this.isProductCheckAll;
        break;
      case 'status' :
        this.isStatusCheckAll = !this.isStatusCheckAll;
        typeCheckAll = this.isStatusCheckAll;
        break;
      case 'redo' :
        this.isRedoCheckAll = !this.isRedoCheckAll;
        typeCheckAll = this.isRedoCheckAll;
        break;
      case 'province' :
        this.isProvinceCheckAll = !this.isProvinceCheckAll;
        typeCheckAll = this.isProvinceCheckAll;
        break;
      case 'dealer' :
        this.isDealerCheckAll = !this.isDealerCheckAll;
        typeCheckAll = this.isDealerCheckAll;
        break;
      case 'store' :
        this.isStoreCheckAll = !this.isStoreCheckAll;
        typeCheckAll = this.isStoreCheckAll;
        break;
      case 'srStatus' :
        this.isSrStatusCheckAll = !this.isSrStatusCheckAll;
        typeCheckAll = this.isSrStatusCheckAll;
        break;
      case 'soStatus' :
        this.isSoStatusCheckAll = !this.isSoStatusCheckAll;
        typeCheckAll = this.isSoStatusCheckAll;
        break;
      default :
        break;
    }

    Object.keys(form.controls).forEach(key => {
      form.controls[key].setValue(typeCheckAll);
    });

    // "All" covers the rows on screen, which after an HQ pick or a search is a
    // subset — keep the sticky set in step with exactly those
    if (type === 'dealerStore' && this.isSeaFamily) {
      Object.keys(form.controls).forEach(key => {
        if (typeCheckAll) {
          this.selectedStoreIds.add(String(key));
        } else {
          this.selectedStoreIds.delete(String(key));
        }
      });
    }
  }

  changeCheckBoxStatus(form, type) {
    let checkCnt = 0;
    Object.keys(form.controls).forEach(key => {
      if (form.controls[key].value) {
        checkCnt++;
      }
    });
    const typeCheckAll = Object.keys(form.controls).length === checkCnt;
    switch (type) {
      case 'dealerStore' :
        this.isDealerStoreCheckAll = typeCheckAll;
        break;
      case 'customer' :
        this.isCustomerTypeCheckAll = typeCheckAll;
        break;
      case 'detail' :
        this.isDetailTypeCheckAll = typeCheckAll;
        break;
      case 'service' :
        this.isServiceTypeCheckAll = typeCheckAll;
        break;
      case 'product' :
        this.isProductCheckAll = typeCheckAll;
        break;
      case 'status' :
        this.isStatusCheckAll = typeCheckAll;
        break;
      case 'redo' :
        this.isRedoCheckAll = typeCheckAll;
        break;
      case 'province' :
        this.isProvinceCheckAll = typeCheckAll;
        break;
      case 'dealer' :
        this.isDealerCheckAll = typeCheckAll;
        break;
      case 'store' :
        this.isStoreCheckAll = typeCheckAll;
        break;
      case 'srStatus' :
        this.isSrStatusCheckAll = typeCheckAll;
        break;
      case 'soStatus' :
        this.isSoStatusCheckAll = typeCheckAll;
        break;
      default :
        break;
    }
  }

  setStores(init?) {
    const provinces = [];
    Object.keys(this.provinceForm.controls).forEach(key => {
      if (this.provinceForm.controls[key].value) {
        provinces.push(key);
      }
    });

    const form = this.dealerForm;
    const dealers = [];
    Object.keys(form.controls).forEach(key => {
      if (form.controls[key].value) {
        dealers.push(key);
      }
    });

    let query = {};
    let stores;
    this.storeList = [];
    if (dealers.length > 0 && dealers.length !== this.dealerList.length) {
      stores = this.store.filter(s => dealers.includes(s.hqBpNo));
    } else {
      stores = this.store;
    }

    if (provinces.length > 0 && this.provinceList.length !== provinces.length) {
      stores = stores.filter(s => provinces.includes(s.state));
    }

    this.storeForm = this.fb.group(query);
    const selectedStore = this.filter.store || [];
    Object.keys(stores).forEach(key => {
      this.storeList.push({
        name: stores[key].name,
        code: stores[key].code,
      })
      query[stores[key].code] = init ? selectedStore.includes(stores[key].code) : false;
    });
    this.storeForm = this.fb.group(query);
  }


}
